/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { InjectionToken } from '@angular/core';

import { IAppConfig } from './app-config.interfaces';

export const APP_CONFIG = new InjectionToken<IAppConfig>('appConfig');
